var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CustomModal",
    {
      staticClass: "basic-modal extra-content-edit-modal",
      attrs: { id: "extra-content-edit-modal", isCustomFooter: true }
    },
    [
      _c(
        "div",
        {
          staticClass: "extra-content-edit-modal__title",
          attrs: { slot: "modal-header" },
          slot: "modal-header"
        },
        [
          _vm._v("\n    긴지문 설정\n    "),
          _c(
            "button",
            {
              staticClass: "btn btn-danger ml-20",
              attrs: { type: "button", disabled: !_vm.hasExtraContent },
              on: {
                click: function($event) {
                  return _vm.remove()
                }
              }
            },
            [_vm._v("\n      삭제\n    ")]
          )
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "extra-content-edit-modal__form" }, [
        _c("div", { staticClass: "form-group" }, [
          _c(
            "label",
            {
              staticClass:
                "typography--body-3 typography--color-secondary typography--font-weight-600",
              attrs: { for: "extra-content-title-input" }
            },
            [_vm._v("\n        제목\n      ")]
          ),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.extraContentTitle,
                expression: "extraContentTitle"
              }
            ],
            staticClass: "form-control",
            attrs: { type: "text", id: "extra-content-title-input" },
            domProps: { value: _vm.extraContentTitle },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.extraContentTitle = $event.target.value
              }
            }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group" }, [
          _c(
            "label",
            {
              staticClass:
                "typography--body-3 typography--color-secondary typography--font-weight-600 clickable"
            },
            [
              _vm._v("\n        긴지문 이미지\n        "),
              _c("img", {
                attrs: { src: "/static/images/ic-camera.svg", alt: "" }
              }),
              _vm._v(" "),
              _c("input", {
                staticClass: "no-display",
                attrs: {
                  type: "file",
                  accept: "image/png,image/jpeg,image/jpg"
                },
                on: { change: _vm.onExtraContentImageChange }
              })
            ]
          ),
          _vm._v(" "),
          _c("div", {
            staticClass: "extra-content-image",
            style: _vm.extraContentImgaeBinding
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", { attrs: { slot: "modal-footer" }, slot: "modal-footer" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-secondary mr-10",
            attrs: { type: "button" },
            on: {
              click: function($event) {
                return _vm.$emit("cancel")
              }
            }
          },
          [_vm._v("\n      취소\n    ")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-primary",
            attrs: { type: "button" },
            on: {
              click: function($event) {
                return _vm.save()
              }
            }
          },
          [_vm._v("\n      저장\n    ")]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-40d50e02", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-40d50e02","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/publishers/components/ExtraContentEditModal.vue
// module id = 0OjA
// module chunks = 1